import React from 'react';
import styled from 'styled-components';
import { GlobalToken, Modal, Popover } from 'antd';

import { useStores } from '@/hooks/use-stores';
import CloseIcon from '@/assets/icon-close.svg?react';
import IconMinimize from '@/assets/icon-minimize.svg?react';

interface EpModalProps {
  children: JSX.Element;
  footer?: JSX.Element;
  width?: string;
  height?: string;
  isMinimizable?: boolean;
  [x: string]: unknown;
}

const EpModal = ({
  children,
  footer = null,
  width = '1440px',
  height = '800px',
  isMinimizable,
  ...rest
}: EpModalProps) => {
  const { mapBuilderStore } = useStores();
  const wheelEventHandler = e => {
    e.stopPropagation();
  };

  const mousedownEventHandler = e => {
    e.stopPropagation();
  };

  return (
    <div onWheel={wheelEventHandler} onMouseDown={mousedownEventHandler}>
      <StyledModal
        destroyOnClose
        footer={footer}
        width={width}
        height={height}
        closeIcon={isMinimizable ? <IconsMinimizableContainer /> : <IconsNonMinimizableContainer />}
        onCancel={mapBuilderStore.closeMaximizedModal}
        {...rest}
      >
        {children}
      </StyledModal>
    </div>
  );
};

const IconsMinimizableContainer = () => {
  const { mapBuilderStore } = useStores();
  return (
    <IconsContainer>
      <div className="close-icons">
        <Popover placement="right" content={'Minimize this screen to view the map along with devices details'}>
          <IconMinimize onClick={mapBuilderStore.minimizeModal} />
        </Popover>
      </div>
      <div className="close-icons">
        <CloseIcon onClick={mapBuilderStore.closeMaximizedModal} />
      </div>
    </IconsContainer>
  );
};

const IconsContainer = styled.div`
  display: flex;
  overflow: visible;
  margin-left: -${({ theme: { token } }) => token.marginXXL}px;
  margin-top: -${({ theme: { token } }) => token.marginXXS}px;

  .close-icons {
    display: flex;
    padding: 0 ${({ theme: { token } }) => token.paddingXXS}px;
  }
`;

const IconsNonMinimizableContainer = () => {
  const { mapBuilderStore } = useStores();
  return (
    <Icon>
      <div className="close-icons">
        <CloseIcon onClick={mapBuilderStore.closeMaximizedModal} />
      </div>
    </Icon>
  );
};

const Icon = styled.div`
  margin-left: -${({ theme: { token } }) => token.margin}px;
  margin-top: -${({ theme: { token } }) => token.marginXXS}px;

  .close-icons {
    padding: 0 ${({ theme: { token } }) => token.paddingXXS}px;
  }
`;

interface StyledModalProps {
  width: string;
  height: string;
  theme: { token: GlobalToken };
}

const StyledModal = styled(Modal)<StyledModalProps>`
  width: ${({ width }) => width};
  min-width: ${({ width }) => width};
  height: ${({ height }) => height};

  .ant-modal-content {
    height: fit-content;
    background-color: ${({ theme: { token } }) => token.colorBgBase};
    padding: 0;

    .ant-modal-close {
      .ant-modal-close-x {
        height: 35px;
      }

      &:hover {
        background-color: transparent;
      }
    }

    .ant-modal-body {
      display: flex;
      height: 100%;
      padding: ${({ theme: { token } }) => token.paddingXL}px;
    }
  }
`;

export default EpModal;
